<template>
  <div class="contentWrap boxed">
    <div class="userProfile">
        <div class="profileImg">
              <div class="userAccount">
              <div class="userAccount__image">
                  <img class="user_img" src="../../assets/gamebox/imgs/dummy_account.jpeg"/>
              </div>
              <div class="userAccount__name">
                  <h3 class="d2-h3 ">{{ $t("hello") }}, Sarah McWilson!</h3>
              </div>
            
              </div>
        </div>
         <div class="d2-section ">
              <div class="d2-section __content">
              <div class="d2-inputWrap">
                    <label  class="d2-label">{{ $t('registered_num') }}:</label>
                    <h4 class="d2-h4">{{msisdn_gamebox}}</h4>
                  </div>
                  <div class="d2-inputWrap">
                    <label  class="d2-label">{{ $t('subscription_date') }}:</label>
                    <h4 class="d2-h4">{{subscription_date_gamebox}}</h4>
                  </div>
                  <div class="d2-inputWrap">
                    <label for="" class="d2-label">{{ $t('next_renew_date') }}:</label>
                    <h4 class="d2-h4">{{renew_date_gamebox}}</h4>
                  </div>
                  <div class="btnContainer " v-if="auth_gamebox === 'loggedin'">
                    <div v-if="is_unsub_gamebox != '0' && countryCode !== 'fi'">
                      <a @click="logout_gamebox(is_unsub_gamebox)" href="" class="d2-button d2-button--alert">{{ $t("unsubscribe") }}</a>
                    </div>
                    <div v-else-if="countryCode === 'fi'">
                    </div>
                    <div v-else>
                      <a @click="logout_gamebox(is_unsub_gamebox)"  href="/logout" class="d2-button d2-button--alert">{{ $t("unsubscribe") }}</a>
                    </div>
                  </div>
                </div>
            </div>  
    </div>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_gamebox",
    "renew_date_gamebox",
    "subscription_date_gamebox",
    "auth_gamebox",
    "is_unsub_gamebox",
    "countryCode"
  ]),
  methods: {
    ...mapActions(["logout_gamebox"])
  }
};
</script>

<style scoped lang="scss">
.userProfile {
  max-width: 580px;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  padding: 25px;
  border-radius: 5px;
  .d2-h3,
  .d2-h4 {
    color: #000;
  }
}
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .d2-inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Profile.vue